import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, ChevronLeft, ChevronRight } from 'lucide-react';
import Header from './components/Header15';
import Footer from './components/Footer15';

const Template15Shop = () => {
    const navigate = useNavigate();
    const [activeFilter, setActiveFilter] = useState('All');
    const [sortBy, setSortBy] = useState('featured');
    const [currentPage, setCurrentPage] = useState(1);
    const [wishlist, setWishlist] = useState({});
    const [hoveredCard, setHoveredCard] = useState(null);

    const categories = ['All', 'Chiffon Sarees', 'Silk Dupattas', 'Anarkalis', 'Drape Dresses'];

    const sortOptions = [
        { value: 'featured', label: 'Featured' },
        { value: 'price-low', label: 'Price: Low to High' },
        { value: 'price-high', label: 'Price: High to Low' },
        { value: 'newest', label: 'Newest First' },
    ];

    const products = [
        { id: 1, name: 'Ocean Breeze Chiffon Saree', category: 'Chiffon Sarees', price: 7999, image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 2, name: 'Silk Cascade Dupatta', category: 'Silk Dupattas', price: 3499, image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 3, name: 'Flowing Teal Anarkali', category: 'Anarkalis', price: 8999, image: 'https://images.pexels.com/photos/3014853/pexels-photo-3014853.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 4, name: 'Ivory Drape Dress', category: 'Drape Dresses', price: 6499, image: 'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 5, name: 'Sapphire Georgette Saree', category: 'Chiffon Sarees', price: 11999, image: 'https://images.pexels.com/photos/6712360/pexels-photo-6712360.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 6, name: 'Pearl White Silk Dupatta', category: 'Silk Dupattas', price: 4999, image: 'https://images.pexels.com/photos/7275385/pexels-photo-7275385.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 7, name: 'Midnight Blue Anarkali Set', category: 'Anarkalis', price: 14999, image: 'https://images.pexels.com/photos/8953474/pexels-photo-8953474.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 8, name: 'Wave Pattern Drape Gown', category: 'Drape Dresses', price: 1999, image: 'https://images.pexels.com/photos/2955375/pexels-photo-2955375.jpeg?auto=compress&cs=tinysrgb&w=400' },
    ];

    const filteredProducts = activeFilter === 'All'
        ? products
        : products.filter(p => p.category === activeFilter);

    const sortedProducts = [...filteredProducts].sort((a, b) => {
        if (sortBy === 'price-low') return a.price - b.price;
        if (sortBy === 'price-high') return b.price - a.price;
        return 0;
    });

    const toggleWishlist = (e, productId) => {
        e.stopPropagation();
        setWishlist(prev => ({ ...prev, [productId]: !prev[productId] }));
    };

    const totalPages = 3;

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&family=Nunito+Sans:wght@300;400;600&display=swap');

                .samundar-shop-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 16px;
                }
                @media (min-width: 768px) {
                    .samundar-shop-grid {
                        grid-template-columns: repeat(3, 1fr);
                        gap: 20px;
                    }
                }
                @media (min-width: 1024px) {
                    .samundar-shop-grid {
                        grid-template-columns: repeat(4, 1fr);
                        gap: 24px;
                    }
                }
                .samundar-filter-bar {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    align-items: center;
                }
                @media (min-width: 768px) {
                    .samundar-filter-bar {
                        flex-direction: row;
                        justify-content: space-between;
                    }
                }
                .samundar-category-scroll {
                    display: flex;
                    gap: 10px;
                    overflow-x: auto;
                    padding-bottom: 4px;
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
                .samundar-category-scroll::-webkit-scrollbar {
                    display: none;
                }
                .samundar-shop-hero {
                    padding: 100px 24px 48px;
                }
                @media (min-width: 768px) {
                    .samundar-shop-hero {
                        padding: 120px 24px 60px;
                    }
                }
            `}</style>

            <div style={{ minHeight: '100vh', backgroundColor: '#FEFCE8', fontFamily: "'Nunito Sans', -apple-system, sans-serif" }}>
                <Header cartCount={0} />

                {/* Hero Banner */}
                <div
                    className="samundar-shop-hero"
                    style={{ backgroundColor: '#FEFCE8', textAlign: 'center' }}
                >
                    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                        <p style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '13px', fontWeight: 600, color: '#1E40AF', letterSpacing: '3px', textTransform: 'uppercase', margin: '0 0 12px 0' }}>
                            Curated for you
                        </p>
                        <h1 style={{ fontFamily: "'Quicksand', sans-serif", fontSize: 'clamp(32px, 6vw, 56px)', fontWeight: 700, color: '#1E293B', letterSpacing: '1px', margin: '0 0 12px 0', lineHeight: 1.1 }}>
                            Our Collection
                        </h1>
                        <p style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '16px', fontWeight: 300, color: '#64748B', margin: 0, lineHeight: 1.6 }}>
                            Discover flowing fabrics that celebrate the art of graceful Indian fashion
                        </p>
                    </div>
                </div>

                {/* Divider wave */}
                <div style={{ width: '100%', overflow: 'hidden', lineHeight: 0 }}>
                    <svg viewBox="0 0 1440 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', display: 'block' }}>
                        <path d="M0,20 C360,40 720,0 1080,20 C1260,30 1350,25 1440,20 L1440,40 L0,40 Z" fill="#FEF9C3" />
                    </svg>
                </div>

                {/* Main Content */}
                <div style={{ backgroundColor: '#FEF9C3' }}>
                    <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '24px 24px 80px' }}>

                        {/* Filter / Sort Bar */}
                        <div className="samundar-filter-bar" style={{ marginBottom: '32px' }}>
                            <div className="samundar-category-scroll">
                                {categories.map(category => (
                                    <button
                                        key={category}
                                        onClick={() => { setActiveFilter(category); setCurrentPage(1); }}
                                        style={{
                                            fontFamily: "'Nunito Sans', sans-serif",
                                            fontSize: '13px',
                                            fontWeight: 600,
                                            padding: '10px 24px',
                                            backgroundColor: activeFilter === category ? '#1E40AF' : 'transparent',
                                            color: activeFilter === category ? '#FFFFFF' : '#1E293B',
                                            border: activeFilter === category ? '2px solid #1E40AF' : '2px solid rgba(30, 64, 175, 0.2)',
                                            borderRadius: '9999px',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s ease',
                                            whiteSpace: 'nowrap',
                                        }}
                                        onMouseEnter={(e) => {
                                            if (activeFilter !== category) {
                                                e.currentTarget.style.borderColor = '#1E40AF';
                                                e.currentTarget.style.color = '#1E40AF';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (activeFilter !== category) {
                                                e.currentTarget.style.borderColor = 'rgba(30, 64, 175, 0.2)';
                                                e.currentTarget.style.color = '#1E293B';
                                            }
                                        }}
                                    >
                                        {category}
                                    </button>
                                ))}
                            </div>

                            <select
                                value={sortBy}
                                onChange={(e) => setSortBy(e.target.value)}
                                style={{
                                    fontFamily: "'Nunito Sans', sans-serif",
                                    fontSize: '13px',
                                    color: '#1E293B',
                                    backgroundColor: '#FEFCE8',
                                    border: '2px solid rgba(30, 64, 175, 0.2)',
                                    borderRadius: '9999px',
                                    padding: '10px 40px 10px 16px',
                                    outline: 'none',
                                    cursor: 'pointer',
                                    appearance: 'none',
                                    WebkitAppearance: 'none',
                                    MozAppearance: 'none',
                                    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%231E40AF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'right 14px center',
                                    minWidth: '180px',
                                }}
                            >
                                {sortOptions.map(option => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                        </div>

                        {/* Results count */}
                        <p style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '13px', color: '#64748B', margin: '0 0 24px 0' }}>
                            Showing {sortedProducts.length} {sortedProducts.length === 1 ? 'piece' : 'pieces'}
                        </p>

                        {/* Product Grid */}
                        <div className="samundar-shop-grid">
                            {sortedProducts.map(product => (
                                <div
                                    key={product.id}
                                    onClick={() => navigate(`/template15/product/${product.id}`)}
                                    onMouseEnter={() => setHoveredCard(product.id)}
                                    onMouseLeave={() => setHoveredCard(null)}
                                    style={{
                                        backgroundColor: '#FEFCE8',
                                        borderRadius: '16px',
                                        cursor: 'pointer',
                                        transition: 'all 0.4s ease',
                                        overflow: 'hidden',
                                        boxShadow: hoveredCard === product.id
                                            ? '0 12px 32px rgba(30, 64, 175, 0.12)'
                                            : '0 2px 8px rgba(30, 64, 175, 0.06)',
                                        transform: hoveredCard === product.id ? 'translateY(-4px)' : 'translateY(0)',
                                    }}
                                >
                                    <div style={{ position: 'relative', aspectRatio: '3 / 4', overflow: 'hidden', borderRadius: '16px 16px 0 0' }}>
                                        <img
                                            src={product.image}
                                            alt={product.name}
                                            style={{
                                                width: '100%', height: '100%', objectFit: 'cover',
                                                transform: hoveredCard === product.id ? 'scale(1.05)' : 'scale(1)',
                                                transition: 'transform 0.5s ease',
                                            }}
                                        />
                                        <button
                                            onClick={(e) => toggleWishlist(e, product.id)}
                                            style={{
                                                position: 'absolute', top: '12px', right: '12px',
                                                width: '36px', height: '36px',
                                                backgroundColor: 'rgba(254, 252, 232, 0.85)',
                                                border: 'none', borderRadius: '50%',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                cursor: 'pointer', backdropFilter: 'blur(4px)',
                                            }}
                                        >
                                            <Heart size={18} style={{ color: wishlist[product.id] ? '#1E40AF' : '#64748B', fill: wishlist[product.id] ? '#1E40AF' : 'none' }} />
                                        </button>
                                    </div>
                                    <div style={{ padding: '16px' }}>
                                        <h3 style={{ fontFamily: "'Quicksand', sans-serif", fontSize: '14px', fontWeight: 600, color: '#1E293B', margin: '0 0 8px 0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                            {product.name}
                                        </h3>
                                        <span style={{ fontFamily: "'Nunito Sans', sans-serif", fontSize: '16px', fontWeight: 600, color: '#1E40AF' }}>
                                            {'\u20B9'}{product.price.toLocaleString('en-IN')}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Pagination */}
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', marginTop: '60px' }}>
                            <button
                                onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                                disabled={currentPage === 1}
                                style={{
                                    width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    backgroundColor: '#FEFCE8', border: '2px solid rgba(30, 64, 175, 0.2)', borderRadius: '50%',
                                    color: currentPage === 1 ? 'rgba(30, 64, 175, 0.2)' : '#1E40AF',
                                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer', transition: 'all 0.3s ease',
                                }}
                            >
                                <ChevronLeft size={18} />
                            </button>
                            {[1, 2, 3].map(page => (
                                <button
                                    key={page}
                                    onClick={() => setCurrentPage(page)}
                                    style={{
                                        width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        fontFamily: "'Nunito Sans', sans-serif", fontSize: '14px',
                                        fontWeight: currentPage === page ? 600 : 400,
                                        backgroundColor: currentPage === page ? '#1E40AF' : '#FEFCE8',
                                        color: currentPage === page ? '#FFFFFF' : '#1E40AF',
                                        border: currentPage === page ? '2px solid #1E40AF' : '2px solid rgba(30, 64, 175, 0.2)',
                                        borderRadius: '50%', cursor: 'pointer', transition: 'all 0.3s ease',
                                    }}
                                >
                                    {page}
                                </button>
                            ))}
                            <button
                                onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                                disabled={currentPage === totalPages}
                                style={{
                                    width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    backgroundColor: '#FEFCE8', border: '2px solid rgba(30, 64, 175, 0.2)', borderRadius: '50%',
                                    color: currentPage === totalPages ? 'rgba(30, 64, 175, 0.2)' : '#1E40AF',
                                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', transition: 'all 0.3s ease',
                                }}
                            >
                                <ChevronRight size={18} />
                            </button>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Template15Shop;
